<script lang="ts">
  import clsx from 'clsx';

  const { sizeClass = 'w-full h-full' }: { sizeClass?: string } = $props();
</script>

<svg
  class={clsx(sizeClass, 'overflow-hidden align-middle')}
  viewBox="0 0 18 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.52125 13.8184C9.20124 13.6229 8.79876 13.6229 8.47875 13.8184L5.17397 15.8369C4.41487 16.3006 3.47362 15.6167 3.68001 14.7515L4.57852 10.9847C4.66553 10.6199 4.54116 10.2372 4.25637 9.99322L1.31539 7.47396C0.639853 6.89529 0.999379 5.78878 1.88603 5.7177L5.74612 5.40823C6.11991 5.37827 6.44552 5.1417 6.58953 4.79546L8.07668 1.21993C8.41827 0.398636 9.58173 0.398636 9.92332 1.21993L11.4105 4.79546C11.5545 5.1417 11.8801 5.37827 12.2539 5.40823L16.114 5.7177C17.0006 5.78878 17.3601 6.89529 16.6846 7.47396L13.7436 9.99322C13.4588 10.2372 13.3345 10.6199 13.4215 10.9847L14.32 14.7515C14.5264 15.6167 13.5851 16.3006 12.826 15.8369L9.52125 13.8184Z"
    fill="currentColor"
  />
</svg>
